<div class="floating-chat-container">
  <!-- Chat button (always visible) -->
  <button class="chat-toggle-btn" (click)="toggleChat()" [class.open]="isOpen">
    <i *ngIf="!isOpen" class="bi bi-robot"></i>
    <svg
      *ngIf="isOpen"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
      />
    </svg>
  </button>

  <!-- Chat window -->
  <div class="chat-window" [class.show]="isOpen">
    <div class="chat-header">
      <h3>Asistente Virtual</h3>
      <button class="close-btn" (click)="closeChat()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
          />
        </svg>
      </button>
    </div>
    <div class="chat-content">
      <iframe
        src="https://jolly-smoke-09f26cf03.2.azurestaticapps.net/"
        frameborder="0"
      >
      </iframe>
    </div>
  </div>
</div>
